export const EDITOR_WATCH_PLUGIN_HOST_WAIT_TIME = 40;
